// UserHeader.js
import React, { useCallback, useEffect, useRef, useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom';
import logo from '../../images/logo.png';
import userIcon from '../../images/userIcon.png';
import notiIcon from '../../images/notiIcon.png';
import nvaIcon from '../../images/nvaIcon.png';
import userPic from '../../images/userPic.png';
import partnerIcon from '../../images/partnerIcon.png';
import searchIconn from '../../images/searchIconn.png';
import matchesIcon from '../../images/matchesIcon.png';
import sendInterestIcon from '../../images/sendInterestIcon.png';
import featuredProfilesIcon from '../../images/featuredProfilesIcon.png';
import chatIconn from '../../images/chatIconn.png';
import eventIcon from '../../images/eventIcon.png';
import settingIcon from '../../images/settingIcon.png';
import helpSupportIcon from '../../images/helpSupportIcon.png';
import customerCareIcon from '../../images/customerCareIcon.png';
import shareIcon from '../../images/shareIcon.png';
import logoutIcon from '../../images/logoutIcon.png';
import crownIcon from '../../images/crownIcon.png';
import { AccountCircle, Mail } from '@mui/icons-material';
import profileImage from "../../images/no-photo.png";
import { Badge } from '@mui/material';
import { notificaionCount } from '../../asiosConfig';
import { toast } from 'react-toastify';
import { styled } from '@mui/material/styles';
import MessengerModal from '../MessengerModel';

const StyledBadge = styled(Badge)(({ theme }) => ({
  '& .MuiBadge-dot': {
    top: '5px !important', // Adjust top position
    right: '3px', // Adjust right position
  },
}));

function UserHeader() {
  const [navOpen, setNavOpen] = useState(false);
  const menuRef = useRef(null);
  const location = useLocation();
  const navigate = useNavigate();
  const backdropRef = useRef(null);
  const completeStep = localStorage.getItem('last_complete_step');
  const [count, setCount] = useState(0);
  const hiddenPaths = ["/careerDetails", "/contactReligion", "/lifeStyle", "/phone-verification-otp"];
  const toggleNav = () => {
    setNavOpen(prev => !prev);
  };
  const shouldHideIcons = hiddenPaths.includes(location.pathname);
  const users = JSON.parse(localStorage.getItem('user'));
  const [userName, setUserName] = useState(null);
  const [photo, setPhoto] = useState(null);
  const [accountType, setAccountType] = useState(null);
  const image_path = localStorage.getItem('image_path');
  const [openMessengerModal, setOpenMessengerModal] = useState(false);


  useEffect(() => {
    const user = localStorage.getItem('user_name');
    const profilePhoto = localStorage.getItem('profilePic');
    const account_type = localStorage.getItem('account_type');


    if (user) {
      setUserName(user);
    }
    if (profilePhoto) {
      setPhoto(profilePhoto);
    }
    if (account_type) {
      setAccountType(account_type);
    }
    const fetchNotificationCount = async () => {
      try {
        const response = await notificaionCount();
        if (response.status === 200 || response.status === 201) {
          setCount(response.data.data);
        } else {
          toast.error("Failed to fetch notification count");
        }
      } catch (error) {
        toast.error(error?.response?.data?.message);
      }
    };
    fetchNotificationCount();
  }, []);
  const handleKeyDown = useCallback((event) => {
    if (event.key === 'Escape') {
      setNavOpen(false);
    }
  }, []);
  const handleClickOutside = useCallback((event) => {
    if (
      menuRef.current && !menuRef.current.contains(event.target) &&
      backdropRef.current && !backdropRef.current.contains(event.target)
    ) {
      setNavOpen(false);
    }
  }, []);
  const handleLogout = () => {
    localStorage.clear();
    navigate('/login');
    window.location.reload();
  }
  useEffect(() => {
    if (navOpen) {
      document.addEventListener("keydown", handleKeyDown);
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("keydown", handleKeyDown);
      document.removeEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [navOpen, handleKeyDown, handleClickOutside]);
  return (
    <section className="topBlockBG fixed-top">
      <div className="container">
        <div className="d-flex justify-content-between align-items-center">
          <div className="logo">
            <a href="#"><img src={logo} className="img-fluid" alt="logo-img" /></a>
          </div>
          <div className="mobileEmailSec">
            {!shouldHideIcons && (
              <>
                <Link to='/view-profile'><img src={userIcon} alt="user icon" /></Link>
                <Link to='/notification'>
                  <StyledBadge badgeContent={count} color="secondary" overlap="circular">
                    <img src={notiIcon} />
                  </StyledBadge>
                </Link>
                <a href="#" onClick={toggleNav}>
                  <img id="nav-button" aria-label="Nav menu" aria-expanded={navOpen} src={nvaIcon} alt="nav menu icon" />
                </a>

              </>
            )}

            {/* NAV */}
            <header>
              <nav>
                <ul id="menu" className={navOpen ? 'visible' : ''} ref={menuRef}>
                  <div className="d-flex align-items-center userNavBG">
                    <div className="flex-shrink-0">
                      <img
                        src={photo ? photo : profileImage}
                        className="img-fluid"
                        alt="profile image"
                        style={{ width: '60px', height: '60px', borderRadius: '50%' }}
                      />
                    </div>
                    <div className="flex-grow-1 ms-3">
                      <p className="navUserName">{userName}</p>
                      <p>{accountType} Member</p>
                    </div>
                  </div>
                  <br />

                  <li><Link to='/search' onClick={() => setNavOpen(false)}><img src={searchIconn} alt="search icon" />&nbsp; Search</Link></li>
                  <li><Link to='/my_matches' onClick={() => setNavOpen(false)}><img src={matchesIcon} alt="matches icon" />&nbsp; Matches</Link></li>
                  {/* <li><Link to='/activity'><img src={sendInterestIcon} alt="matches icon" />&nbsp; Active Profiles</Link></li> */}
                  <li><Link to='/featured_profile' onClick={() => setNavOpen(false)}><img src={featuredProfilesIcon} alt="featured profiles icon" />&nbsp; Featured Profiles</Link></li>
                  <li>
                    <Link
                      to="#"
                      onClick={(e) => {
                        e.preventDefault();
                        setNavOpen(false);
                        setOpenMessengerModal(true);
                      }}
                    >
                      <img src={chatIconn} alt="chat icon" />&nbsp; Chat
                    </Link>
                  </li>
                  <li><Link to='/view-profile' onClick={() => setNavOpen(false)}><img src={partnerIcon} alt="partner icon" />&nbsp; Partner Preferences</Link></li>
                  {/* <li><a href="#"><img src={eventIcon} alt="event icon" />&nbsp; Events</a></li> */}
                  <li><Link to='/setting' onClick={() => setNavOpen(false)}><img src={settingIcon} alt="settings icon" />&nbsp; Settings</Link></li>
                  {/* <li><a href="#"><img src={helpSupportIcon} alt="help support icon" />&nbsp; Help & Support</a></li> */}
                  <li><Link to='/customer-care' onClick={() => setNavOpen(false)}><img src={customerCareIcon} alt="customer care icon" />&nbsp; Customer Care</Link></li>
                  {/* <li><a href="#"><img src={featuredProfilesIcon} alt="rate us icon" />&nbsp; Rate Us</a></li> */}
                  {/* <li><a href="#"><img src={shareIcon} alt="share icon" />&nbsp; Share</a></li> */}
                  <li><Link onClick={handleLogout} to="/login"><img src={logoutIcon} alt="share icon" />&nbsp;Logout</Link></li>
                  <a href="/upgrade" className="upgradeBTN text-center">
                    <img src={crownIcon} alt="upgrade membership icon" /> &nbsp; UPGRADE MEMBERSHIP
                  </a>
                </ul>
                {navOpen && <div id="backdrop" className="backdrop backdrop--visible" aria-hidden="true" ref={backdropRef} onClick={() => setNavOpen(false)}></div>}
              </nav>
            </header>
            {/* NAV */}
          </div>
        </div>
      </div>
      <MessengerModal
        open={openMessengerModal}
        onClose={() => setOpenMessengerModal(false)}
      />

    </section>
  )
}

export default UserHeader